import Section from '@/components/Section'
import EmailCapture from '@/components/EmailCapture'

export default function WorkshopCTA() {
  return (
    <div className="relative py-24 px-6 text-center overflow-hidden">
      {/* Deep celestial background */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-dark via-[#1A0E38] to-bg-footer z-0" />

      {/* Constellation stars */}
      <div className="absolute inset-0 constellation z-[1]" />

      {/* Breathing orbs */}
      <div
        className="absolute w-72 h-72 rounded-full top-[-80px] left-[8%] animate-breathe-slow z-[1]"
        style={{
          background: 'radial-gradient(circle, rgba(201,150,44,0.12) 0%, transparent 70%)',
        }}
      />
      <div
        className="absolute w-48 h-48 rounded-full bottom-[-40px] right-[12%] animate-breathe z-[1]"
        style={{
          background: 'radial-gradient(circle, rgba(123,82,171,0.15) 0%, transparent 70%)',
        }}
      />

      <Section>
        <div className="relative z-[2] max-w-[560px] mx-auto">
          <span className="inline-block py-1.5 px-4 rounded-full bg-white/[0.06] text-gold-light text-[11px] font-semibold tracking-[2px] uppercase mb-5 border border-gold-light/15">
            Live Workshops
          </span>

          <h2 className="font-display text-[clamp(28px,5vw,42px)] font-bold text-white leading-[1.15] mb-4">
            5 Easy Steps to Incorporate AI<br />in Your Spiritual Leadership
          </h2>

          <p className="text-white/60 text-[17px] leading-relaxed mb-10">
            A hands-on workshop where I walk spiritual leaders through the exact
            tools and workflows I use at my own center. No jargon. No overwhelm.
            Just practical steps you can implement this week.
          </p>

          <div className="flex justify-center">
            <EmailCapture
              placeholder="Your email for workshop updates"
              buttonText="Notify Me"
              source="workshop"
              type="subscriber"
              dark
            />
          </div>

          <p className="text-white/30 text-xs mt-4">
            No spam. Just workshop dates and early access to new tools.
          </p>
        </div>
      </Section>
    </div>
  )
}
